/*
 * types/services/dr2am.tasks.orders.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbOrder} from './PbOrder';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceListOrderssResponse model module.
 * @module model/ServiceListOrderssResponse
 * @version version not set
 */
export class ServiceListOrderssResponse {
  /**
   * Constructs a new <code>ServiceListOrderssResponse</code>.
   * @alias module:model/ServiceListOrderssResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceListOrderssResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceListOrderssResponse} obj Optional instance to populate.
   * @return {module:model/ServiceListOrderssResponse} The populated <code>ServiceListOrderssResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceListOrderssResponse();
      if (data.hasOwnProperty('orders'))
        obj.orders = ApiClient.convertToType(data['orders'], [PbOrder]);
      if (data.hasOwnProperty('next_page_token'))
        obj.nextPageToken = ApiClient.convertToType(data['next_page_token'], 'String');
      if (data.hasOwnProperty('total'))
        obj.total = ApiClient.convertToType(data['total'], 'String');
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/PbOrder>} orders
 */
ServiceListOrderssResponse.prototype.orders = undefined;

/**
 * @member {String} nextPageToken
 */
ServiceListOrderssResponse.prototype.nextPageToken = undefined;

/**
 * @member {String} total
 */
ServiceListOrderssResponse.prototype.total = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceListOrderssResponse.prototype.state = undefined;


